import { type DependencyList, useEffect, useRef } from 'react';

type UseScrollIntoViewProps =
    | {
          deps?: DependencyList;
          options?: ScrollIntoViewOptions;
      }
    | undefined;

const defaultOptions: ScrollIntoViewOptions = { behavior: 'smooth' };

export function useScrollIntoView(props?: UseScrollIntoViewProps) {
    const { deps = [], options = defaultOptions } = props || {};
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollIntoView(options);
        }
    }, [...deps, options]);

    return ref;
}
